import { render, staticRenderFns } from "./PurchaseRequestApprovalSummary.vue?vue&type=template&id=43ec8aab&scoped=true"
import script from "./PurchaseRequestApprovalSummary.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestApprovalSummary.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestApprovalSummary.vue?vue&type=style&index=0&id=43ec8aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec8aab",
  null
  
)

export default component.exports